// extracted by mini-css-extract-plugin
export default {"title":"heading_title__JuIgp"};